import React from 'react';
import {
  BrandLogo,
  DescriptionText,
  LoginButton,
  LoginContainer,
  SelectCountryText,
  SignInContainer,
} from './SignIn.style';
import { ThemeProvider } from '@mtnkente/cl-super-app-foundation';
import { Logo } from '@mtnkente/paragon-display/logo';
import { Text } from '@mtnkente/paragon-display/text';
import { StandardButton } from '@mtnkente/paragon-buttons/standard-button';
import { useAuth0 } from '@auth0/auth0-react';

const SignIn: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLoginClick = React.useCallback((): void => {
    loginWithRedirect().catch((error) => {
      console.error('Login failed:', error);
    });
  }, [loginWithRedirect]);

  return (
    <ThemeProvider mode={'light'} platform={'core'}>
      <SignInContainer>
        <LoginContainer>
          <BrandLogo>
            <Logo $logoType='core' $size='small' $variant='default' />
          </BrandLogo>
          <SelectCountryText>
            <Text $fontStyle='title-large-bold'>PWA Login</Text>
          </SelectCountryText>
          <DescriptionText>
            <Text $fontStyle='body-small-regular'>
              proceed to your secured localised login page
            </Text>
          </DescriptionText>
          <LoginButton>
            <StandardButton
              $variant='primary'
              label='Login'
              $isFullWidth
              onClick={handleLoginClick}
            />
          </LoginButton>
        </LoginContainer>
      </SignInContainer>
    </ThemeProvider>
  );
};

export default SignIn;
